import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[colorContrast]',
  standalone: true,
})
export class SiaColorContrastDirective {
  private elem = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() set colorContrast(value: string | undefined) {
    // console.log('SiaColorContrastDirective', value);
    if (!value) {
      return;
    }
    if (value?.indexOf('rgb') !== -1) {
      const rgb = value
        .replace(/[a-zA-Z()]/g, '')
        .replace(/\s/g, '')
        .split(',');

      // Ensure we have 3 values
      if (rgb.length !== 3) {
        throw new Error('Invalid RGB string format');
      }

      // Convert each component to an integer and then to hex
      const hex = rgb
        .map((x) => {
          const integer = parseInt(x, 10);
          if (isNaN(integer) || integer < 0 || integer > 255) {
            throw new Error('RGB values must be between 0 and 255');
          }
          return integer.toString(16).padStart(2, '0');
        })
        .join('');

      value = hex;
    }
    // console.log('valore hex', value);
    value = this.stripNumberSign(value);
    this.renderer.setStyle(
      this.elem.nativeElement,
      `color`,
      '#' + this.getContrastYIQ(value),
    );
  }

  DARK = '000000';
  LIGHT = 'FFFFFF';
  @HostListener('window:unload')
  ngOnDestroy() {
    this.elem.nativeElement.remove();
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  stripNumberSign(color: string) {
    if (color[0] === '#') {
      color = color.substring(1, color.length);
    }
    return color;
  }
  getContrastYIQ(hexcolor: string) {
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? this.DARK : this.LIGHT;
  }
}
